import { getDiarysList } from "./CommonFunc";
function DairyList(props) {
	const openDairy = (id) => {
		props.setCurrentDiary(props.diarys.find((element) => element.ID === id));
	};
	return (
		<>
			{props.diarys
				.map((item) => ({ id: item.ID, mnemo: item.TAB_MNEMO }))
				.map((item) => (
					<div
						key={item.id}
						className={`button-tab ${
							props.currentDiary.ID === item.id ? "active" : ""
						}`}
						onClick={() => {
							openDairy(item.id);
						}}
					>
						{item.mnemo}
					</div>
				))}
		</>
	);
}

export default DairyList;
